import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type PageFooterProps = {
  children: ReactNode;
};

const StyledPageFooter = styled('footer')({
  padding: 16,
});

export const PageFooter = ({ children }: PageFooterProps) => {
  return <StyledPageFooter>{children}</StyledPageFooter>;
};
